<template>
    <section class="kanban-column">
        <section class="header">
            <div>
                <div class="title">
                    <span
                        :class="{ 'abbreviate': hasLink || toString(number).length > 2 }"
                        class="text"
                        :title="title">
                        {{ title }}
                    </span>
                    <div v-show="hasLink" class="link" @click="goLink">
                        <em class="far fa-external-link"/>
                    </div>
                </div>
                <div>
                    <span v-if="totalNegotiation !== undefined" :class="getClassForTotalNegotiations(typeNegotiation)"> {{ totalNegotiation | currencyBRL }} </span>
                    <div v-else class="total-value-content" />
                </div>
            </div>

            <div class="config">
                <div v-show="!!number" class="itens-number">{{ number }}</div>
            </div>

            <div class="action-menu-card">
                <filter-kanban
                    :for-status="isStatus"
                    :idles="idles"
                    :status="status"
                    @filter="filterHandler"
                    @clear="clearHandler" />
            </div>

            <div class="arrow-right" :style="hasArrow">
                <div class="arrow-right-top"/>
                <div class="arrow-right-bottom"/>
            </div>
            <div v-if="hasArrow" class="last-table" />
        </section>

        <perfect-scrollbar v-scroll-paginate="scrollHandler">
            <section class="body">
                <slot name="body"/>
                <div v-show="(number == 0 || !number) && !loading" class="empty-column">
                    <div class="text">Nenhum Cliente nessa Etapa!</div>
                </div>

                <div v-show="loading && !number" class="loading-area">
                    <ui-load-indicator bg-color="#D1CFDF" color="#69D296" :h="50" :stroke="8" />
                </div>
            </section>
        </perfect-scrollbar>
    </section>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'
	import { scrollPaginate } from '@/directives'
	import filterKanban from './components/filter'
	import { currencyBRL } from '@/filters';

	export default {
		name: 'kanban-column',
		components: {
			uiLoadIndicator,
			filterKanban
		},

		directives: {
			scrollPaginate,
		},

		filters: {
			currencyBRL,
		},

		props: {
			title: {
				type: String,
				required: true,
			},

			typeNegotiation: {
				type: String,
				required: true,
			},

			totalNegotiation: {
				type: String,
				required: true,
			},

			index: {
				type: Number,
				default: 0,
			},

			hasLink: {
				type: Boolean,
				default: false,
			},

			linkAction: {
				type: Function,
				default: () => {
					return
				},
			},

			linkPayload: {
				type: [Number, String],
				default: null,
			},

			number: {
				type: Number,
				default: 0,
			},

			status: {
				type: [Array, Object],
				required: true
			},

			/**
			 * Prop contendo as regras de ociosidade da etapa
			 */
			idles: {
				type: Array,
				required: true
			},

			loading: {
				type: Boolean,
				default: false,
			},
			/**
			 *	Prop para indicar se o objeto column representa um status ou uma etapa
			 */
			isStatus: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * ID do funil em questão pra redirecionar corretamente
			 */
			 funnelId:{
				type:[String, Number],
				required:false,
			}
		},

		computed: {
			hasArrow() {
				return this.title === 'Venda Perdida' ? 'display: none' : ''
			}
		},

		methods: {
			scrollHandler() {
				this.$emit('next', this.index)
			},

			goLink() {
				this.linkAction(this.funnelId, this.linkPayload, this.title)
			},
			/**
			 * Função handler que emite o evento de filtro da coluna, passando o índice e
			 * os parâmetros de filtragem
			 */
			filterHandler(params) {
				this.$emit('filter', { id: this.index, params })
			},
			/**
			 * Função handler que emite o evento para limpar os dados da filtragem realizada
			 */
			clearHandler() {
				this.$emit('clear', this.index)
			},

			getClassForTotalNegotiations(typeClass) {
				if (typeClass === 'won') {
				return 'total-value-won';
				} else if (typeClass === 'lost') {
				return 'total-value-lost';
				} else {
				return 'total-value';
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
